import { Progress } from '@mantine/core';
import { transactionTeamPriorityColorIndex } from '@repo/services';
import React from 'react';

/**
 * A visual indicator component that renders a full-height progress bar colored according to the transaction's health status (green, yellow, or red).
 */
export const HealthComponent = ({ health }: any) => {
  const progress = 100;

  return (
    <Progress.Root
      radius={0}
      // style={style}
      w={30}
      style={{ rotate: '270deg', position: 'relative', left: -5, translate: '-50% 15px', width: 8 }}
      //{/*{{, translate: '-50% -0px', width: '100%' }}*/}
      color={
        transactionTeamPriorityColorIndex[health as keyof typeof transactionTeamPriorityColorIndex] ??
        'default'
      }
    >
      {health?.toLowerCase() == 'green' && <Progress.Section value={progress} color={'green'} />}
      {health?.toLowerCase() == 'yellow' && <Progress.Section value={progress} color={'yellow'} />}
      {health?.toLowerCase() == 'red' && <Progress.Section value={progress} color={'red'} />}
    </Progress.Root>
  );
};
